module.exports = __webpack_public_path__ + "img/logo_wide_nav.f5feb61d.svg";